import React from 'react'
import { loadRecaptchaScript } from 'helpers/recaptcha'

export const AuthLayout = ({
    heading,
    title,
    children,
    footer,
}) => {
    // Load reCAPTCHA when a login / password page opens so Google's badge is visible
    // before submitting (v3 shows no checkbox). No-ops when no site key is configured.
    React.useEffect(() => {
        loadRecaptchaScript();
    }, []);

    return (
        <section className="auth_section">
            <div className='card_form_wrapper'>
                <div className='auth_heading'>
                    <img src="/images/logo-fill.png" alt="" />
                    <h1>{heading}</h1>
                    <p>{title}</p>

                </div>
                {children}

                {/* {footer} */}
            </div>
        </section>
    )
}
